import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { apiBase } from 'utils'

import Page from './components/Page'

const CatchAll404 = () => (
  <Route
    render={({
      location,
      match: { params: { slug } }
    }) => (
      <Page
        location={location}
        data={{
          type: 'page-404-bro',
          api: `${apiBase}/pages?slug=${slug}`
        }}
      />
    )}
  />
)

const App = () => (

  <Switch>

    {/* Work routes */}
    <Route
      path='/work'
      render={({ location, match: { url } }) => (
        <Switch>

          {/* Work page */}
          <Route
            exact
            path={`${url}`}
            render={() => (
              <Page
                location={location}
                data={{
                  template: 'page-work',
                  api: `${apiBase}/project?per_page=100`
                }}
              />
            )}
          />

          {/* Project page */}
          <Route
            exact
            path={`${url}/:slug`}
            render={({
              history,
              match: { params: { slug } }
            }) => (
              <Page
                history={history}
                location={location}
                data={{
                  api: `${apiBase}/project?slug=${slug}`
                }}
              />
            )}
          />

          <CatchAll404 />
        </Switch>
      )}
    />

    {/* Work routes */}
    <Route
      path='/fr/projets'
      render={({ location, match: { url } }) => (
        <Switch>

          {/* Work page */}
          <Route
            exact
            path={`${url}`}
            render={() => (
              <Page
                location={location}
                data={{
                  template: 'page-work',
                  api: `${apiBase}/project?per_page=100&lang=fr`
                }}
              />
            )}
          />

          {/* Project page */}
          <Route
            exact
            path={`${url}/:slug`}
            render={({
              history,
              match: { params: { slug } }
            }) => (
              <Page
                history={history}
                location={location}
                data={{
                  api: `${apiBase}/project?slug=${slug}&lang=fr`
                }}
              />
            )}
          />

          <CatchAll404 />
        </Switch>
      )}
    />

    {/* Page routes */}
    <Route
      path='/'
      render={({ location, match: { url } }) => (
        <Switch>

          {/* Expertise page */}
          <Route
            exact
            path={`${url}expertise`}
            render={({ location, history }) => (
              <Page
                history={history}
                location={location}
                data={{
                  template: 'page-expertise',
                  api: `${apiBase}/pages?slug=expertise`
                }}
              />
            )}
          />
          <Route
            exact
            path={`${url}fr/expertise`}
            render={({ location, history }) => (
              <Page
                history={history}
                location={location}
                data={{
                  template: 'page-expertise',
                  api: `${apiBase}/pages?slug=expertise&lang=fr`
                }}
              />
            )}
          />

          {/* Contact page */}
          <Route
            exact
            path={`${url}contact`}
            render={({ location, history }) => (
              <Page
                history={history}
                location={location}
                data={{
                  template: 'page-contact',
                  api: `${apiBase}/pages?slug=contact`
                }}
              />
            )}
          />
          {/* Contact page */}
          <Route
            exact
            path={`${url}fr/contact`}
            render={({ location, history }) => (
              <Page
                history={history}
                location={location}
                data={{
                  template: 'page-contact',
                  api: `${apiBase}/pages?slug=contact&lang=fr`
                }}
              />
            )}
          />

          {/* Homepage route */}
          <Route
            exact
            path={`${url}`}
            render={() => (
              <Page
                location={location}
                data={{
                  api: `${apiBase}/pages?slug=homepage`
                }}
              />
            )}
          />

          <Route
            exact
            path={`${url}fr`}
            render={() => (
              <Page
                location={location}
                data={{
                  api: `${apiBase}/pages?slug=homepage&lang=fr`
                }}
              />
            )}
          />

          {/* Any page route */}
          <Route
            exact
            path={`${url}:slug`}
            render={({
              history,
              match: { params: { slug } }
            }) => (
              <Page
                history={history}
                location={location}
                data={{
                  api: `${apiBase}/pages?slug=${slug}`
                }}
              />
            )}
          />

          <CatchAll404 />
        </Switch>
      )}
    />

    <CatchAll404 />

  </Switch>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js